App.PolygonTransform = DS.Transform.extend
  deserialize: (serialized) ->
    return Em.A([]) unless serialized?

    str = serialized.replace('POLYGON ((', '').replace('))','')
    Em.A(str?.split(', ')).map (coords) ->
      [y, x] = coords.split(' ')
      [parseFloat(x), parseFloat(y)]

  serialize: (deserialized) ->
    return '' unless deserialized?
    str = deserialized.map((p) -> "#{p[1]} #{p[0]}").join(', ')
    "POLYGON ((#{str}))"
